<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item prop="merchantShortname">
              <span slot="label" ><a-tooltip>{{$t('商户简称')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                <a-input v-model="queryParam.merchantShortname" :maxLength="32" :placeholder="$t('请输入')+'商户简称'" allow-clear @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item prop="subMchid">
              <span slot="label" ><a-tooltip>{{$t('二级商户号')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                <a-input v-model="queryParam.subMchid" :maxLength="32" :placeholder="$t('请输入')+'二级商户号(审核通过后)'" allow-clear @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item prop="applymentState">
              <span slot="label" ><a-tooltip>{{$t('申请状态')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                <a-input v-model="queryParam.applymentState" :maxLength="32" :placeholder="$t('请输入')+'申请状态 CHECKING/AUDITING/FINISH/REJECTED等'" allow-clear @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建开始时间')" prop="createBeginTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                   :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                   valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建结束时间')" prop="createEndTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                   :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                   valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd(merchantId)" v-hasPermi="['merchant:extraapplyweixin:add']">
          <a-icon type="plus" />{{$t('新增')}}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['merchant:extraapplyweixin:edit']">
          <a-icon type="edit" />{{$t('修改')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" :merchantId="merchantId" :merchantType="merchantType" @ok="getList"/>
      <!-- 数据展示 -->
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: '1200' }"
        id="draggable-table"
        class="draggable-table"
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-button size="small" type="link" @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['merchant:extraapplyweixin:edit']">
             <a-icon type="edit" />{{$t('修改')}}
          </a-button>
          <a-button type="link" size="small" @click="handleWeixinApply(record)" style="color: #f30202"  v-if="!record.subMchid">
            <a-icon type="edit" />进件
          </a-button>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {
  pageExtraApplyWeixin,
  delExtraApplyWeixin,
  applyExtraApplyWeixin
} from '@/api/merchant/extraApplyWeixin'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import {downLoadExcel} from "@/utils/excelDownload";

export default {
  name: 'ExtraApplyWeixin',
  components: {
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      merchantId: undefined,
      merchantType: undefined,
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        organizationType: undefined,
        financeInstitution: undefined,
        idHolderType: undefined,
        idDocType: undefined,
        authorizeLetterCopy: undefined,
        certType: undefined,
        businessLicenseCopy: undefined,
        businessLicenseNumber: undefined,
        merchantName: undefined,
        legalPerson: undefined,
        companyAddress: undefined,
        businessTime: undefined,
        financeType: undefined,
        financeLicensePics: undefined,
        idCardCopy: undefined,
        idCardNational: undefined,
        idCardName: undefined,
        idCardNumber: undefined,
        idCardValidTimeBegin: undefined,
        idCardValidTime: undefined,
        idDocName: undefined,
        idDocNumber: undefined,
        idDocCopy: undefined,
        idDocCopyBack: undefined,
        docPeriodBegin: undefined,
        docPeriodEnd: undefined,
        owner: undefined,
        bankAccountType: undefined,
        accountBank: undefined,
        accountName: undefined,
        bankAddressCode: undefined,
        bankBranchId: undefined,
        bankName: undefined,
        accountNumber: undefined,
        contactType: undefined,
        contactName: undefined,
        contactIdDocType: undefined,
        contactIdCardNumber: undefined,
        contactIdDocCopy: undefined,
        contactIdDocCopyBack: undefined,
        contactIdDocPeriodBegin: undefined,
        contactIdDocPeriodEnd: undefined,
        businessAuthorizationLetter: undefined,
        mobilePhone: undefined,
        storeName: undefined,
        storeUrl: undefined,
        storeQrCode: undefined,
        miniProgramSubAppid: undefined,
        settlementId: undefined,
        qualificationType: undefined,
        merchantShortname: undefined,
        qualifications: undefined,
        businessAdditionPics: undefined,
        businessAdditionDesc: undefined,
        subMchid: undefined,
        applymentState: undefined,
        applymentStateDesc: undefined,
        signUrl: undefined,
        signState: undefined,
        legalValidationUrl 　: undefined,
        auditDetail: undefined,
        rejectReason: undefined,
        accountValidation: undefined,
        wxpaySignRequired: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('编号'),
          dataIndex: 'id',
          align: 'center'
        },
        {
          title: this.$t('主体类型'),
          dataIndex: 'organizationType',
          align: 'center'
        },
        {
          title: this.$t('证件持有人类型'),
          dataIndex: 'idHolderType',
          align: 'center'
        },
        {
          title: this.$t('营业执照注册号'),
          dataIndex: 'businessLicenseNumber',
          align: 'center'
        },
        {
          title: this.$t('商户名称'),
          dataIndex: 'merchantName',
          align: 'center'
        },
        {
          title: this.$t('法人姓名'),
          dataIndex: 'legalPerson',
          align: 'center'
        },
        {
          title: this.$t('账户类型'),
          dataIndex: 'bankAccountType',
          align: 'center'
        },
        {
          title: this.$t('开户银行'),
          dataIndex: 'accountBank',
          align: 'center'
        },
        {
          title: this.$t('微信支付申请单号'),
          dataIndex: 'applymentId',
          align: 'center'
        },
        {
          title: this.$t('二级商户号'),
          dataIndex: 'subMchid',
          align: 'center'
        },
        {
          title: this.$t('申请状态'),
          dataIndex: 'applymentState',
          align: 'center'
        },
        {
          title: this.$t('签约状态'),
          dataIndex: 'signState',
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '12%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.pushMerchantId()
    this.getList()
  },
  mounted() {
    this.pushMerchantId()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询商家进件-微信列表 */
    getList () {
      this.loading = true
     pageExtraApplyWeixin(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    pushMerchantId() {
      let merchantId = this.$route.query.merchantId;
      if (merchantId) {
        this.merchantId = merchantId;
        this.merchantType = Number(this.$route.query.merchantType);
      }
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        organizationType: undefined,
        financeInstitution: undefined,
        idHolderType: undefined,
        idDocType: undefined,
        authorizeLetterCopy: undefined,
        certType: undefined,
        businessLicenseCopy: undefined,
        businessLicenseNumber: undefined,
        merchantName: undefined,
        legalPerson: undefined,
        companyAddress: undefined,
        businessTime: undefined,
        financeType: undefined,
        financeLicensePics: undefined,
        idCardCopy: undefined,
        idCardNational: undefined,
        idCardName: undefined,
        idCardNumber: undefined,
        idCardValidTimeBegin: undefined,
        idCardValidTime: undefined,
        idDocName: undefined,
        idDocNumber: undefined,
        idDocCopy: undefined,
        idDocCopyBack: undefined,
        docPeriodBegin: undefined,
        docPeriodEnd: undefined,
        owner: undefined,
        bankAccountType: undefined,
        accountBank: undefined,
        accountName: undefined,
        bankAddressCode: undefined,
        bankBranchId: undefined,
        bankName: undefined,
        accountNumber: undefined,
        contactType: undefined,
        contactName: undefined,
        contactIdDocType: undefined,
        contactIdCardNumber: undefined,
        contactIdDocCopy: undefined,
        contactIdDocCopyBack: undefined,
        contactIdDocPeriodBegin: undefined,
        contactIdDocPeriodEnd: undefined,
        businessAuthorizationLetter: undefined,
        mobilePhone: undefined,
        storeName: undefined,
        storeUrl: undefined,
        storeQrCode: undefined,
        miniProgramSubAppid: undefined,
        settlementId: undefined,
        qualificationType: undefined,
        merchantShortname: undefined,
        qualifications: undefined,
        businessAdditionPics: undefined,
        businessAdditionDesc: undefined,
        subMchid: undefined,
        applymentState: undefined,
        applymentStateDesc: undefined,
        signUrl: undefined,
        signState: undefined,
        legalValidationUrl 　: undefined,
        auditDetail: undefined,
        rejectReason: undefined,
        accountValidation: undefined,
        wxpaySignRequired: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    handleWeixinApply(record) {
      this.loading = true
      applyExtraApplyWeixin({"id":record.id}).then(response => {
        this.loading =false;
        if (response.code==='20001') {
          this.$message.success("进件成功待审核",3)
          this.getList()
        }
      })
    },

    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      let reqData = {"idList":this.ids}
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          return delExtraApplyWeixin(reqData)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(message,3)
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          downLoadExcel('biz/admin/merchant/extra/apply/weixin/export' ,  that.queryParam)
        },
        onCancel () {}
      })
    }
  }
}
</script>
